export default __webpack_public_path__ + "static/media/updates.8de654bf.svg";